import React, { useEffect, useState } from "react";
import { getAuthToken, setAuthToken, setUserInfo } from "../utils";
import { HomePath } from "../routes";
import { useNavigate } from "react-router-dom";
import {
  API_BASE_URL_SSO,
  LOGOUT_REDIRECT_URI,
  TENANT_ID,
} from "../utils/common";
import { Loader } from "@hid-galaxy-ui/galaxy-react";
import { LoaderSizes } from "@hid-galaxy-ui/galaxy-react/components/Loader/loaderEnums";
const Logout = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const doLogout = async () => {
      try {
        await fetch(
          `${API_BASE_URL_SSO}/auth/logout?tenant_id=${TENANT_ID}&post_logout_redirect_uri=${LOGOUT_REDIRECT_URI}`,
          {
            method: "GET",
            headers: {
              accept: "application/json",
              Authorization: `Bearer ${getAuthToken()}`,
            },
          }
        );
      } catch (e) {
        // Optionally handle error
      }
      setUserInfo("");
      setAuthToken("");
      setLoading(false);
      navigate(HomePath);
    };
    doLogout();
  }, []);
  if (loading) {
    return <Loader isOverlay variant={LoaderSizes.medium} />;
  }
  return null;
};
export default Logout;
